import { render, staticRenderFns } from "./SidebarAdmin.vue?vue&type=template&id=ff1bb262&scoped=true&"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js&"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAdmin.vue?vue&type=style&index=0&id=ff1bb262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1bb262",
  null
  
)

export default component.exports